export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_01.308852d2.png";